module.exports = __webpack_public_path__ + "fonts/DINPro-CondBold.c1cf7d95.ttf";